// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ControlMessage, ControlMessageT } from '../control/control-message';
import { ControllerInfoMessage, ControllerInfoMessageT } from '../controller-info/controller-info-message';
import { FaultMessage, FaultMessageT } from '../fault/fault-message';
import { GroupControlMessage, GroupControlMessageT } from '../group-control/group-control-message';
import { GroupSupervisoryStatusMessage, GroupSupervisoryStatusMessageT } from '../group-supervisory-status/group-supervisory-status-message';
import { StatusMessage, StatusMessageT } from '../status/status-message';
import { TrafficMessage, TrafficMessageT } from '../traffic/traffic-message';


export enum BitMaskMessageContent {
  NONE = 0,
  Status_StatusMessage = 1,
  Traffic_TrafficMessage = 2,
  Control_ControlMessage = 3,
  Fault_FaultMessage = 4,
  GroupSupervisoryStatus_GroupSupervisoryStatusMessage = 5,
  GroupControl_GroupControlMessage = 6,
  ControllerInfo_ControllerInfoMessage = 7
}

export function unionToBitMaskMessageContent(
  type: BitMaskMessageContent,
  accessor: (obj:ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage) => ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage|null
): ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage|null {
  switch(BitMaskMessageContent[type]) {
    case 'NONE': return null; 
    case 'Status_StatusMessage': return accessor(new StatusMessage())! as StatusMessage;
    case 'Traffic_TrafficMessage': return accessor(new TrafficMessage())! as TrafficMessage;
    case 'Control_ControlMessage': return accessor(new ControlMessage())! as ControlMessage;
    case 'Fault_FaultMessage': return accessor(new FaultMessage())! as FaultMessage;
    case 'GroupSupervisoryStatus_GroupSupervisoryStatusMessage': return accessor(new GroupSupervisoryStatusMessage())! as GroupSupervisoryStatusMessage;
    case 'GroupControl_GroupControlMessage': return accessor(new GroupControlMessage())! as GroupControlMessage;
    case 'ControllerInfo_ControllerInfoMessage': return accessor(new ControllerInfoMessage())! as ControllerInfoMessage;
    default: return null;
  }
}

export function unionListToBitMaskMessageContent(
  type: BitMaskMessageContent, 
  accessor: (index: number, obj:ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage) => ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage|null, 
  index: number
): ControlMessage|ControllerInfoMessage|FaultMessage|GroupControlMessage|GroupSupervisoryStatusMessage|StatusMessage|TrafficMessage|null {
  switch(BitMaskMessageContent[type]) {
    case 'NONE': return null; 
    case 'Status_StatusMessage': return accessor(index, new StatusMessage())! as StatusMessage;
    case 'Traffic_TrafficMessage': return accessor(index, new TrafficMessage())! as TrafficMessage;
    case 'Control_ControlMessage': return accessor(index, new ControlMessage())! as ControlMessage;
    case 'Fault_FaultMessage': return accessor(index, new FaultMessage())! as FaultMessage;
    case 'GroupSupervisoryStatus_GroupSupervisoryStatusMessage': return accessor(index, new GroupSupervisoryStatusMessage())! as GroupSupervisoryStatusMessage;
    case 'GroupControl_GroupControlMessage': return accessor(index, new GroupControlMessage())! as GroupControlMessage;
    case 'ControllerInfo_ControllerInfoMessage': return accessor(index, new ControllerInfoMessage())! as ControllerInfoMessage;
    default: return null;
  }
}

export type BitMaskMessageContentT =
  | { type: 'NONE'; value: null }
  | { type: 'Status_StatusMessage'; value: StatusMessageT }
  | { type: 'Traffic_TrafficMessage'; value: TrafficMessageT }
  | { type: 'Control_ControlMessage'; value: ControlMessageT }
  | { type: 'Fault_FaultMessage'; value: FaultMessageT }
  | { type: 'GroupSupervisoryStatus_GroupSupervisoryStatusMessage'; value: GroupSupervisoryStatusMessageT }
  | { type: 'GroupControl_GroupControlMessage'; value: GroupControlMessageT }
  | { type: 'ControllerInfo_ControllerInfoMessage'; value: ControllerInfoMessageT };
